import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=aa2a66b6&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2a66b6')) {
      api.createRecord('aa2a66b6', component.options)
    } else {
      api.reload('aa2a66b6', component.options)
    }
    module.hot.accept("./LandingPage.vue?vue&type=template&id=aa2a66b6&", function () {
      api.rerender('aa2a66b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/LandingPage.vue"
export default component.exports